const HEADER_CHAT_LOADING_SKELETON_ROW_COUNT = 4;

export const HEADER_CHAT_LOADING_SKELETON_ROW_KEYS = Array.from(
  { length: HEADER_CHAT_LOADING_SKELETON_ROW_COUNT },
  (_, index) => `header-chat-skeleton-${index}`,
);
